export const LOCAL_STORAGE_KEYS = {
	updateAnnouncementHistoryPrefix: 'flying-update-history:'
} as const;

/** Keys outside these prefixes belong to the current account and are cleared on switching. */
export const PERSISTENT_LOCAL_STORAGE_PREFIXES: readonly string[] = [
	LOCAL_STORAGE_KEYS.updateAnnouncementHistoryPrefix
];
